import routes from 'enum/routeDefinitions';
import { isStudioOwnerCheck } from 'utils/studio';
import {
  propFromImpersonatedStudio,
  usernameOrImpersonate,
} from 'utils/helpers';


export function getSettingsRoute(user) {
  const studio = propFromImpersonatedStudio('username', user.user.getIn(['user', 'studio', 'username']));
  const username = usernameOrImpersonate(user.user.getIn(['user', 'username']));

  const routeInfo = {};
  const userToCheck = usernameOrImpersonate() ? usernameOrImpersonate('', true) : user;
  if (isStudioOwnerCheck(userToCheck)) {
    routeInfo.path = routes.studioSettings;
    routeInfo.param = studio;
  } else {
    routeInfo.path = routes.profileSettings;
    routeInfo.param = username;
  }

  return routes.get(routeInfo.path, { user: routeInfo.param, view: '' });
}
